module.exports = __webpack_public_path__ + "img/icon_logout_white.3ea20d95.svg";